/**
 * Generate JSON-LD schema for Organization
 */
export const getOrganizationSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'RegAI',
  legalName: 'SV Commerce SRLS',
  url: 'https://regai.it',
  logo: 'https://regai.it/logo.svg',
  description:
    'Laboratori AI per scuole: PCTO, formazione docenti, primaria e secondaria. GDPR-ready.',
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'IT',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'Customer Service',
    availableLanguage: ['Italian', 'English'],
  },
});

/**
 * Generate JSON-LD schema for Product/Service
 */
export const getProductSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'Product',
  name: 'RegAI – AI per la Scuola',
  description:
    `Laboratori pratici, percorsi PCTO e formazione docenti per introdurre l'AI in modo sicuro, etico e misurabile.`,
  brand: {
    '@type': 'Brand',
    name: 'RegAI',
  },
  offers: {
    '@type': 'AggregateOffer',
    priceCurrency: 'EUR',
    availability: 'https://schema.org/InStock',
  },
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.8',
    ratingCount: '50',
    bestRating: '5',
    worstRating: '1',
  },
});

/**
 * Generate JSON-LD schema for FAQ
 */
export const getFAQSchema = (faqs: Array<{ question: string; answer: string }>) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
});
